import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// 🚨 PRESIDENTIAL BOARDING PLANK (Director directive 2026.02) 🚨
// Time-bombed header-auth fallback for the public-facing Director identity
// when DNS / cookie-domain alignment is in flux. When `boarding-plank`
// credentials exist in sessionStorage, every API request carries
// `X-Director-Plank-{Email,Password}` headers so the backend can
// authenticate even if the cookie never lands. The credential is held in
// sessionStorage (not localStorage) so it auto-clears when the tab closes.
const PLANK_KEY = "eigoo_boarding_plank";

export function setBoardingPlank({ email, password }) {
    try {
        sessionStorage.setItem(PLANK_KEY, JSON.stringify({ email, password }));
    } catch { /* sessionStorage unavailable — silent noop */ }
}

export function clearBoardingPlank() {
    try { sessionStorage.removeItem(PLANK_KEY); } catch { /* noop */ }
}

export function getBoardingPlank() {
    try {
        const raw = sessionStorage.getItem(PLANK_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch { return null; }
}

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const plank = getBoardingPlank();
    if (plank?.email && plank?.password) {
        config.headers = config.headers || {};
        config.headers["X-Director-Plank-Email"] = plank.email;
        config.headers["X-Director-Plank-Password"] = plank.password;
    }
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
